import React from 'react';
import '../css/GameInfo.css';

function GameInfo({ roomCode, show, round, question, children, isMuted, toggleMute, changeRound }) {
  const airDate = show.airDate?.replace(/^(\d{4})-(\d{2})-(\d{2})$/, (_, year, month, day) =>
    `${Number(month)}/${Number(day)}/${year}`);
  const roundNumber = round
    ? ['jeopardy', 'doubleJeopardy', 'finalJeopardy'].findIndex(key => show.rounds[key] === round) + 1
    : 0;
  return (
    <div className="game-info">
      <div className="game-info-left">
        {roomCode}, {show.id}{question ? '-'+question.id : null}<br/>
        <div className="game-info-actions">
          {toggleMute && (
            <button className="game-info-button game-mute-button" onClick={toggleMute}
              aria-label={isMuted ? 'Unmute audio' : 'Mute audio'} aria-pressed={isMuted}
              title={isMuted ? 'Unmute audio' : 'Mute audio'}>
              <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M11 4 6 8H3v8h3l5 4Z" />
                {isMuted
                  ? <path d="m3 3 18 18" />
                  : <><path d="M15 8a6 6 0 0 1 0 8" /><path d="M18 5a10 10 0 0 1 0 14" /></>}
              </svg>
            </button>
          )}
          {children}
        </div>
      </div>
      <div className="game-info-right">
        {roundNumber > 0 && `Round ${roundNumber}, `}{airDate}<br/>
        {changeRound && (
          <div className="game-info-actions game-round-controls">
            {['jeopardy', 'doubleJeopardy', 'finalJeopardy'].map((key, index) => (
              <button key={key} className="game-info-button" onClick={() => changeRound(show.rounds[key], true)}>
                {index + 1}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default GameInfo;
